import { watch } from 'vue'

import { useCreativeWatchlistStore } from '../stores/creativeWatchlistStore'

import { useWorkspace } from '@/features/account'
import { registerSessionReset } from '@/features/auth'

/** The watchlist store is route-independent by design (the Meta/Google tabs only `v-show`), so
 *  nothing unmounts it: its rows, search, filters and ordering are all tenant data and clear on
 *  both edges. `reset()` also drops the cached account/workspace context, so the next
 *  `selectContext` re-arms the fetch even when it names the same ids. */
export function registerCommerceLifecycle(): () => void {
  const store = useCreativeWatchlistStore()
  const { workspaceId } = useWorkspace()
  const stopWorkspace = watch(
    workspaceId,
    (next, previous) => {
      if (String(next ?? '') !== String(previous ?? '')) store.reset()
    },
    { flush: 'sync' },
  )
  const unregisterSession = registerSessionReset(() => store.reset())
  return () => {
    stopWorkspace()
    unregisterSession()
  }
}
